import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { IndicadoresProjeto } from '../models/indicadores-projeto.model';

@Injectable({
  providedIn: 'root',
})
export class IndicadoresProjetoService extends BaseService<IndicadoresProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getList(id: number, obj: any[] = null): Observable<IndicadoresProjeto[]> {
    return this.http.post<IndicadoresProjeto[]>(this.baseUrl + '/' + id, obj, { headers: this.headers });
  }

  public getFilters(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/filtros/' + id, { headers: this.headers });
  }

  public salvarOrdem(obj: any[]): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/salvar-ordem', obj, { headers: this.headers });
  }

  public getByIdSimple(id: number): Observable<IndicadoresProjeto> {
    return this.http.get<IndicadoresProjeto>(this.baseUrl + '/simplificada/' + id, { headers: this.headers });
  }

  public getByIdList(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list/' + id, { headers: this.headers });
  }

  public getByIdListEdit(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-edit/' + id, { headers: this.headers });
  }

  public getBloqueio(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/bloqueio/' + id, obj, { headers: this.headers });
  }

  public updateSomados(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/somados/' + id, obj, { headers: this.headers });
  }

  public getListIndicadoresRelacionados(id: number): Observable<IndicadoresProjeto[]> {
    return this.http.get<IndicadoresProjeto[]>(this.baseUrl + '/indicadores-relacionados/' + id, { headers: this.headers });
  }

  public getListEntregasRelacionados(id: number): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + '/entregas-relacionadas/' + id, { headers: this.headers });
  }

  public graphTable(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/graph-table/' + id, { headers: this.headers });
  }

  public getListMetaRealizado(id: number): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + '/meta-realizado-list/' + id, { headers: this.headers });
  }

  public getRelatorio(id: number, params: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/relatorio/${id}?${params}`,
      {
        headers: this.headers,
        responseType: 'blob' as 'json'
      }
    );
  }

  public updateMetaRealizado(obj: any, id: number): Observable<any> {
    return this.http.put<any>(this.baseUrl + '/meta-realizado/' + id, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/indicadores';
  }

}
